import { defineSemanticTokens } from '@chakra-ui/react/styled-system';

export const colors = defineSemanticTokens.colors({
	primary: {
		DEFAULT: { value: { base: '{colors.blue.700}', _dark: '{colors.blue.900}' } },
		lighten: { value: { base: '{colors.blue.200}', _dark: '{colors.blue.400}' } },
		_hover: { value: { base: '{colors.blue.500}', _dark: '{colors.blue.700}' } },
		_active: { value: { base: '{colors.blue.800}', _dark: '{colors.blue.800}' } },
	},
	secondary: {
		DEFAULT: { value: { base: '{colors.neutral.700}', _dark: '{colors.teal.900}' } },
		lighten: { value: { base: '{colors.neutral.200}', _dark: '{colors.teal.400}' } },
		_hover: { value: { base: '{colors.neutral.500}', _dark: '{colors.teal.700}' } },
		_active: { value: { base: '{colors.neutral.800}', _dark: '{colors.teal.800}' } },
	},
	info: {
		DEFAULT: { value: { base: '{colors.blue.500}', _dark: '{colors.blue.400}' } },
		lighten: { value: { base: '{colors.blue.50}', _dark: '{colors.blue.50}' } },
		_hover: { value: { base: '{colors.blue.300}', _dark: '{colors.blue.200}' } },
		_active: { value: { base: '{colors.blue.600}', _dark: '{colors.blue.500}' } },
	},
	success: {
		DEFAULT: { value: { base: '{colors.green.600}', _dark: '{colors.green.500}' } },
		lighten: { value: { base: '{colors.green.100}', _dark: '{colors.green.50}' } },
		_hover: { value: { base: '{colors.green.400}', _dark: '{colors.green.300}' } },
		_active: { value: { base: '{colors.green.700}', _dark: '{colors.green.600}' } },
	},
	warning: {
		DEFAULT: { value: { base: '{colors.yellow.500}', _dark: '{colors.yellow.300}' } },
		lighten: { value: { base: '{colors.yellow.50}', _dark: '{colors.yellow.50}' } },
		_hover: { value: { base: '{colors.yellow.300}', _dark: '{colors.yellow.100}' } },
		_active: { value: { base: '{colors.yellow.600}', _dark: '{colors.yellow.400}' } }
	},
	error: {
		DEFAULT: { value: { base: '{colors.red.700}', _dark: '{colors.red.400}' } },
		lighten: { value: { base: '{colors.red.200}', _dark: '{colors.red.50}' } },
		_hover: { value: { base: '{colors.red.500}', _dark: '{colors.red.200}' } },
		_active: { value: { base: '{colors.red.800}', _dark: '{colors.red.500}' } }
	},
	scrollbar: {
		track: { value: { base: 'transparent', _dark: 'transparent' } },
		thumb: { value: { base: 'rgba(0, 0, 0, 0.48)', _dark: 'rgba(255, 255, 255, 0.48)' } }
	},
	disabled: {
		DEFAULT: { value: { base: '{colors.neutral.300}', _dark: '{colors.neutral.600}' } },
		label: { value: { base: '{colors.neutral.50}', _dark: '{colors.neutral.400}' } }
	},
	card: {
		DEFAULT: { value: { base: 'white', _dark: '{colors.neutral.800}' } }
	}
});